import React from 'react';

import Tippy from '@tippyjs/react';

import Icon from 'components/shared/Icon/Icon';

const SupervisionLabel = ({ label, tippyMessage }) => (
  <div className="flex gap-2">
    <div>{label}</div>
    <Tippy content={tippyMessage} className="tippy-dark">
      <div>
        <Icon icon="info-filled" color="neutral" />
      </div>
    </Tippy>
  </div>
);

export default SupervisionLabel;
